module.exports = __webpack_public_path__ + "img/print-accreditation.edf1cac6.svg";